(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('FeeDetailController', FeeDetailController);

    FeeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Fee'];

    function FeeDetailController($scope, $rootScope, $stateParams, previousState, entity, Fee) {
        var vm = this;

        vm.fee = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:feeUpdate', function(event, result) {
            vm.fee = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
